import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase, X } from "lucide-react";

export const demandUrl = (gameId, entry, suppliers) => {
  const p = new URLSearchParams({ new: "1", game_id: gameId, server_id: entry.server_id || "", faction: entry.faction || "", item: entry.product_name });
  suppliers.forEach((s) => { p.append("inv", s.supplier_id); p.append("invn", s.name); });
  return `/demand-board?${p.toString()}`;
};

export default function MultiInviteBar({ picked, gameId, onClear }) {
  const navigate = useNavigate();
  const list = Object.values(picked);
  const servers = [...new Map(list.flatMap((s) => s.entries).filter((e) => e.server_id).map((e) => [e.server_id, e])).values()];
  const [serverId, setServerId] = useState("");
  if (!list.length) return null;
  const entry = servers.find((e) => e.server_id === serverId) || servers[0];
  const onServer = entry ? list.filter((s) => s.entries.some((e) => e.server_id === entry.server_id)).length : 0;

  return (
    <div data-testid="multi-invite-bar" className="sticky bottom-4 z-30 mt-4 flex flex-wrap items-center gap-3 bg-[#141519]/95 backdrop-blur-md border border-[#D4AF37]/60 rounded-lg px-4 py-3 shadow-[0_10px_40px_rgba(0,0,0,0.5)] fade-in">
      <span data-testid="multi-invite-count" className="text-sm text-[#F5F3ED]"><b className="text-[#D4AF37]">{list.length}</b> supplier dipilih</span>
      <div className="hidden sm:flex flex-wrap gap-1.5 max-w-full">{list.map((s) => <span key={s.supplier_id} className="text-[11px] bg-[#D4AF37]/15 text-[#D4AF37] rounded-full px-2 py-0.5">{s.name}</span>)}</div>
      <div className="flex-1" />
      {servers.length > 0 ? (
        <>
          <select data-testid="multi-invite-server" value={entry?.server_id || ""} onChange={(e) => setServerId(e.target.value)}
            className="bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] rounded-sm px-2 py-1.5 text-xs outline-none">
            {servers.map((e) => <option key={e.server_id} value={e.server_id}>{e.server_name}{e.faction ? ` · ${e.faction}` : ""}</option>)}
          </select>
          {onServer < list.length && <span className="text-[10px] text-[#F2D98D]">{list.length - onServer} supplier tidak punya stok di server ini, tetap diundang</span>}
          <button data-testid="multi-invite-create" onClick={() => navigate(demandUrl(gameId, entry, list))}
            className="inline-flex items-center gap-1.5 bg-[#D4AF37] hover:bg-[#F2D98D] text-[#101114] font-bold text-xs rounded-sm px-3 py-2 transition-colors"><Briefcase size={13} /> Buat Demand & Undang {list.length}</button>
        </>
      ) : <span className="text-xs text-[#F2D98D]">Supplier terpilih tidak punya stok dengan server</span>}
      <button data-testid="multi-invite-clear" onClick={onClear} className="text-[#A8A8AD] hover:text-[#F5F3ED]" title="Batalkan pilihan"><X size={16} /></button>
    </div>
  );
}
